export enum OrderDate {
    LAST_MONTH = 1,
    LAST_TWO_MONTHES = 2
}
